/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const productDetailsTabsDescriptionSX: SxProps<Theme> = {
	maxWidth: '65ch',
	'& > h3, & > p, & ul': {
		margin:0
	}
};

export const productAttrRowSX: SxProps<Theme> = {
	display:'flex', 
	alignItems:'center',
	'& > span':{
		fontSize: 16,
	}
}

export const productAttrLabelSX: SxProps<Theme> = {
	minWidth: globalBreak({mobile:200, desktop:300}),
	maxWidth: globalBreak({mobile:200, desktop:300}),
	fontSize: 16,
	alignSelf: 'flex-start',
	padding:'5px 0'
}

export const productCustomAttrLabelSX: SxProps<Theme> = {
	minWidth: globalBreak({mobile:200, desktop:300}),
	maxWidth: globalBreak({mobile:200, desktop:300}),
	mt:2,
	fontSize: 18,
	fontWeight: 'bold',
	alignSelf: 'flex-start',
	padding:'5px 0'
}

export const showHideDescriptionSX:SxProps = {
	cursor:'pointer',
	fontSize:globalBreak({mobile:'16px !important', desktop:'inherit'}),
}

export const tabsDescriptionMobileSX:SxProps = {
	'& .MuiAccordion-root':{
		borderBottom: '1px solid',
		'& .MuiAccordionSummary-root':{
			p: 0,
			pt: 2,
			'& .MuiAccordionSummary-content .MuiTypography-root': {
				fontWeight: 'bold'
			},
			'& .MuiAccordionSummary-expandIconWrapper': {
				p: 0,
			}
		}
	},
	'& .MuiAccordion-root:last-of-type': {
		borderBottomLeftRadius: 0,
		borderBottomRightRadius: 0
	}
}

export const productAttrValueSX: SxProps<Theme> = {
	 wordBreak: 'break-word'
}
